import { render, staticRenderFns } from "./DesignerList.vue?vue&type=template&id=5287fd0b"
import script from "./DesignerList.vue?vue&type=script&lang=js"
export * from "./DesignerList.vue?vue&type=script&lang=js"
import style0 from "./DesignerList.vue?vue&type=style&index=0&id=5287fd0b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports